'use strict';
import adModal from './quiz.model.html';

const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './quiz.routes';

export class QuizComponent {

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;

        this.language_type_selector = [
            {value: 'en', name: '英语'},
            {value: 'pt', name: '葡语'},
            {value: 'es', name: '西语'},
        ];

        this.filters = {
            language_type: 'en'
        };
    }

    $onInit() {
        this.totalCount = 0;
        this.search();
    }

    search() {
        if(!this.filters.language_type) {
            this.filters.language_type = 'en';
        }
        this.$http.get('/api/quizs/backstage', {
            params: this.filters
        })
            .then(response => {
                if(response.data.data) {
                    this.adDefaults = response.data.data;
                    this.totalCount = response.data.data.length;
                }
            });
    }

    createOne() {
        const that = this;
        this.$uibModal.open({
            template: adModal,
            size: 'lg',
            /*@ngInject*/
            controller($scope, $http, $uibModalInstance) {
                $scope.vm = {};
                $scope.cancel = function() {
                    $uibModalInstance.close();
                };

                $scope.save = function(myForm) {
                    if(myForm.$valid === false) {
                        return false;
                    } else {
                        $http.post('/api/quizs', $scope.vm).then(response => {
                            that.$onInit();
                            $uibModalInstance.close();
                        }, error => {
                            console.log(error);
                        });
                    }
                };
            }
        });
    }

    delete(ad) {
        this.$http.delete(`/api/quizs/${ad._id}`)
            .then(response => {
                this.$onInit();
            });
    }

    edit(ad) {
        const that = this;
        this.$uibModal.open({
            template: adModal,
            size: 'lg',
            /*@ngInject*/
            controller($scope, $http, $uibModalInstance, FileUploader) {
                $scope.vm = ad;
                $scope.cancel = function() {
                    $uibModalInstance.close();
                };

                $scope.save = function(myForm) {
                    if(myForm.$valid === false) {
                        return false;
                    } else {
                        $http.post('/api/quizs', $scope.vm).then(response => {
                            that.$onInit();
                            $uibModalInstance.close();
                        }, error => {
                            console.log(error);
                        });
                    }
                };
            }
        });
    }
}

export default angular.module('tttApp.quiz', [uiRouter])
    .config(routes)
    .component('quiz', {
        template: require('./quiz.html'),
        controller: QuizComponent,
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/quiz/quiz.component.js